export const getCompanyData = async () => {
    try {
        const response = await fetch("/enrichment/reveal", { method: "GET" });
        const companyData = await response.json();

        return { data: companyData, success: true, loaded: true };
    } catch (err) {
        console.log(err);
        return { success: false, loaded: true };
    }
};